import axios from "axios"

const controller = "/app"

const AppService = {
    getData: async (request) => {
        const { data } = await axios.post(`${controller}/getData`, request)
        return data
    },
}

export default AppService